import GLOBALS from '../config/globals';

const { PLAYOFF_ROUND_NAMES, PLAYOFF_SERIES_NAMES, PLAYOFF_GAMES_PER_SERIES } = GLOBALS;

export const getSeriesAndRound = (currentRound) => {
    const round = Number(currentRound);
    if (!Number.isFinite(round) || round < 1) return '';

    const maxSeries = PLAYOFF_SERIES_NAMES.length - 1;
    const seriesIndex = Math.min(maxSeries, Math.ceil(round / PLAYOFF_GAMES_PER_SERIES));
    const gameInSeries = ((round - 1) % PLAYOFF_GAMES_PER_SERIES) + 1;

    const seriesName = PLAYOFF_SERIES_NAMES[seriesIndex] ?? `Series ${seriesIndex}`;
    const roundName = PLAYOFF_ROUND_NAMES[gameInSeries] ?? `Game ${gameInSeries}`;
    return `${seriesName} ${roundName}`.trim();
};

/**
 * Returns the trophy tier earned based on where the run ended.
 * null = no trophy (eliminated in AA).
 */
export const getPlayoffTrophyTier = (currentRound, status) => {
    if (status === GLOBALS.PLAYOFF_STATUS.CHAMPION) return { tier: 'gold', label: 'Gold Trophy' };
    if (status === GLOBALS.PLAYOFF_STATUS.ELIMINATED) {
        const completedSeries = Math.floor((currentRound - 1) / PLAYOFF_GAMES_PER_SERIES);
        if (completedSeries >= 2) return { tier: 'silver', label: 'Silver Trophy' };
        if (completedSeries >= 1) return { tier: 'bronze', label: 'Bronze Trophy' };
    }
    return null;
};
